import React, { useState, useEffect } from 'react';
import { Monitor, Smartphone } from 'lucide-react';
import { Button } from './ui/button';

export default function ViewToggle() {
  const [isMobileView, setIsMobileView] = useState(true);

  useEffect(() => {
    // Check saved preference
    const savedView = localStorage.getItem('viewMode');
    if (savedView === 'desktop') {
      setIsMobileView(false);
      enableDesktopView();
    } else {
      setIsMobileView(true);
      enableMobileView();
    }
  }, []);

  const enableDesktopView = () => {
    // Force desktop viewport
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=1280, initial-scale=0.5, maximum-scale=2.0, user-scalable=yes');
    }
    document.body.classList.add('force-desktop-view');
    document.body.classList.remove('force-mobile-view');
  };

  const enableMobileView = () => {
    // Restore mobile viewport
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
    }
    document.body.classList.remove('force-desktop-view');
    document.body.classList.add('force-mobile-view');
  };

  const toggleView = () => {
    const newView = !isMobileView;
    setIsMobileView(newView);
    
    if (newView) {
      localStorage.setItem('viewMode', 'mobile');
      enableMobileView();
    } else {
      localStorage.setItem('viewMode', 'desktop');
      enableDesktopView();
    }

    // Reload to apply changes properly
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <Button
      onClick={toggleView}
      variant="outline"
      size="sm"
      className="fixed bottom-20 left-4 z-50 bg-white shadow-lg border-2 border-blue-600"
      title={isMobileView ? 'Switch to Desktop View' : 'Switch to Mobile View'}
    >
      {isMobileView ? (
        <>
          <Monitor className="h-4 w-4 mr-2" />
          <span className="hidden sm:inline">Desktop View</span>
        </>
      ) : (
        <>
          <Smartphone className="h-4 w-4 mr-2" />
          <span className="hidden sm:inline">Mobile View</span>
        </>
      )}
    </Button>
  );
}
